import React from 'react';
import classes from './block4.module.css';
import command1 from '../../images/command1.png'
import command2 from '../../images/command2.png'
import command3 from '../../images/command3.png'
import { API_BASE_URL } from '../../../config/api';
import img1 from './images/img.png'
import img2 from './images/img_1.png'
import img3 from './images/img_2.png'
import img4 from './images/img_3.png'
import img5 from './images/img_4.png'
import img6 from './images/img_5.png'
import img7 from './images/img_6.png'
import img8 from './images/img_7.png'

const Block4 = () => {
    const fallbackStylists = React.useMemo(
        () => [
            {
                id: "fallback-1",
                photo: command1,
                profession: "Ведущий стилист и арт-директор",
                name: "Владимир",
                description:
                    "Арт - директор салона, работающий в бьюти - индустрии с 2017 года, и совмещающий эту профессию наравне с деятельностью в тату - индустрии, что свидетельствует о его творческом подходе к клиенту.\nПри создании образа в классических стрижках предпочитает совмещать элегантность и простоту, разбавляя это нотками безукоризненного внимания к деталям. При выборе креативной стрижки способен помочь воплотить любые, казалось бы даже самые безумные на первый взгляд идеи, используя индивидуальный подход и художественный взгляд при создании образа, не оставляя равнодушным никого.\nДоброжелательный, безукоризненный, немного педантичный, творческий и возможно даже капельку безумный!",
            },
            {
                id: "fallback-2",
                photo: command2,
                profession: "Руководитель /  мужской бровист",
                name: "Екатерина",
                description:
                    "Руководитель салона мужской эстетики «Л.Е.В.» и мужской бровист.\nВ индустрии красоты с 2017 года, главный принцип — эстетика во всём: в людях, в деталях, и, конечно, в безупречных бровях. Последние несколько лет Екатерина посвятила узкой специализации — работе с мужскими бровями.\nЕё философия — подчеркнуть индивидуальность и создать идеальный баланс с чертами лица, сохраняя естественность и ухоженный вид.",
            },
            {
                id: "fallback-3",
                photo: command3,
                profession: "Ведущий стилист с 11-летним стажем",
                name: "Денис",
                description:
                    "Ведущий стилист, работающий в бьюти - индустрии с 2012 года. Стрижет уделяя максимум внимания к деталям, учитывая не только форму лица, но и характер. Сможет сделать вас как строгим и статным, так и лёгким и молодежным.\nВас ждут как  классические, так и современные стрижки, аккуратное бритьё, уход за бородой и усами — всё для того, чтобы подчеркнуть вашу уникальность.",
            },
        ],
        []
    );
    const [stylists, setStylists] = React.useState(fallbackStylists);
    const [activeStylistId, setActiveStylistId] = React.useState(null);
    const activeStylist = stylists.find((item) => item.id === activeStylistId) || null;

    React.useEffect(() => {
        if (!activeStylistId) return undefined;
        const onKey = (event) => {
            if (event.key === 'Escape') setActiveStylistId(null);
        };
        document.addEventListener('keydown', onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [activeStylistId]);

    React.useEffect(() => {
        fetch(`${API_BASE_URL}/api/stylists/`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to load stylists');
                }
                return response.json();
            })
            .then((data) => {
                if (!Array.isArray(data) || data.length === 0) {
                    return;
                }
                const normalized = data.map((item, index) => ({
                    ...item,
                    photo: item.photo && !item.photo.startsWith('http')
                        ? `${API_BASE_URL}${item.photo}`
                        : item.photo,
                    id: item.id || `stylist-${index}`,
                }));
                setStylists(normalized);
            })
            .catch(() => {
                setStylists(fallbackStylists);
            });
    }, [fallbackStylists]);

    return (
        <div className={classes._} id={'about'}>
            <div className={classes.block}>
                <div className={classes.text1}>Наши стилисты</div>
                <div className={classes.commandBlock}>
                    {stylists.map((stylist, index) => (
                        <button
                            type="button"
                            className={classes.commandItem}
                            key={stylist.id}
                            onClick={() => setActiveStylistId(stylist.id)}
                            aria-haspopup="dialog"
                            aria-expanded={activeStylistId === stylist.id}
                        >
                            {index === 0 && <img src={img1} alt="" className={classes.img1}/>}
                            {index === 2 && <img src={img2} alt="" className={classes.img2}/>}
                            <img src={stylist.photo} alt={stylist.name} className={classes.commandImage}/>
                            <div className={classes.commandLine}></div>
                            <div className={classes.commandInfo}>
                                <div className={classes.commandText1}>{stylist.profession}</div>
                                <div className={classes.commandText2}>{stylist.name}</div>
                                <div className={classes.commandText3} style={{ whiteSpace: 'pre-line' }}>
                                    {stylist.description}
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
                {activeStylist && (
                    <div
                        className={classes.stylistModalOverlay}
                        onClick={() => setActiveStylistId(null)}
                        role="presentation"
                    >
                        <div
                            className={classes.stylistModal}
                            role="dialog"
                            aria-modal="true"
                            aria-labelledby={`stylist-modal-title-${activeStylist.id}`}
                            onClick={(event) => event.stopPropagation()}
                        >
                            <button
                                type="button"
                                className={classes.stylistModalClose}
                                onClick={() => setActiveStylistId(null)}
                                aria-label="Закрыть"
                            >
                                ×
                            </button>
                            <img
                                src={activeStylist.photo}
                                alt={activeStylist.name}
                                className={classes.stylistModalPhoto}
                            />
                            <div className={classes.commandText1}>{activeStylist.profession}</div>
                            <div
                                id={`stylist-modal-title-${activeStylist.id}`}
                                className={classes.commandText2}
                            >
                                {activeStylist.name}
                            </div>
                            <div className={classes.stylistModalText} style={{ whiteSpace: 'pre-line' }}>
                                {activeStylist.description}
                            </div>
                        </div>
                    </div>
                )}
                <div>
                    <img src={img3} alt={''} className={classes.img3} />
                    <img src={img4} alt={''} className={classes.img4} />
                    <img src={img5} alt={''} className={classes.img5} />
                    <img src={img6} alt={''} className={classes.img6} />
                    <img src={img6} alt={''} className={classes.img7} />
                    <div className={classes.text2}>
                        Индивидуальный подход. Качество которое Вы оцените. Сервис от которого Вам будет хотеться приходить чаще! Приватная, чисто мужская обстановка и атмосфера!<br/><br/>
                        В работе мы учитываем Ваши черты лица, структуру волос, образ жизни и внутренний стержень. Наша философия — не просто выполнить услугу, а раскрыть Ваш личный стиль, подчеркнув Вашу харизму.<br/><br/>
                        <span className={classes.text2Span}>Л.Е.В.</span> — это не просто аббревиатура. Это принцип нашего подхода к вам:<br/>
                        <span className={classes.text2Span}>Л</span>ичный стиль<br/>
                        <span className={classes.text2Span}>Е</span>стественность<br/>
                        <span className={classes.text2Span}>В</span>еликолепный результат<br/><br/>
                        <span className={classes.text2Span}>ГЛУБОКАЯ КОНСУЛЬТАЦИЯ</span>
                        <br/>(для наших клиентов совершенно БЕСПЛАТНО):<br/><br/>
                        прежде чем взять в руки инструменты, мы проводим детальную консультацию, анализируем форму вашего лица, тип волос, привычки в укладке и, что важно, ваши пожелания и образ жизни. Результат должен быть не только стильным, но и удобным для Вас каждый день.
                    </div>
                    <div className={classes.text3}>
                        <span className={classes.text2Span}>ПЕРСОНАЛЬНЫЙ ПРОЕКТ СТРИЖКИ:</span><br/>
                        Мы не работаем по шаблонам. На основе консультации наш стилист создает персональный проект стрижки и ухода, который идеально гармонирует с вашим образом. Исправляем неудавшиеся стрижки (частый запрос), а также разработаем для Вас дальнейшую программу стрижек до достижения желаемого результата.<br/><br/>
                        <span className={classes.text2Span}>ТОЧНЫЙ ПОДБОР СРЕДСТВ:</span><br/>
                        Мы поможем подобрать средства для ухода и укладки, которые решают именно ваши задачи: подходят по типу волос, желаемой текстуре и фиксации. Вы забудете о полках, заставленных ненужными баночками. При желании качественные уходовые средства, которые подходят именно ВАМ (после консультации со стилистом), Вы можете купить прямо у нас в салоне и не тратить время на поиск, и деньги на не подходящие Вам средства).<br/><br/>
                        <span className={classes.text2Span}>КОМФОРТ И ДОВЕРИЕ:</span><br/>
                        Мы создаем атмосферу, где вы можете расслабиться и полностью довериться мастеру. Ваш комфорт и удовлетворение результатом — наш главный приоритет.<br/><br/>
                        <span className={classes.text2Span}>КОНЦЕПЦИЯ ВСЁ В ОДНОМ МЕСТЕ:</span><br/>
                        В нашей жизни время - основной ресурс. Вы можете привести себя в полный порядок в одном месте благодаря нашим ПРОФЕССИОНАЛАМ. Профессиональный мужской бровист подчеркнет Вашу стрижку и образ, а мастер ногтевого сервиса приведет Ваши руки в порядок, депиляцией воском уберем лишние волосы на лице.
                    </div>
                    <img src={img7} alt={''} className={classes.img8} />
                    <img src={img8} alt={''} className={classes.img9} />
                </div>
            </div>
        </div>
    );
};

export default Block4;